module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0103.png.47eaf27f.jpg";